module.exports = __webpack_public_path__ + "img/money-icon.f9688ca.png";